module.exports = __webpack_public_path__ + "static/media/chia-work-8.fdd190db.jpg";